import { Box, Button, Collapse } from '@mui/material';
import { useState } from 'react';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

export type RawDataProps = {
  data: any;
  title?: string;
  alwaysExpand?: boolean;
  disableButton?: boolean;
};

/**
 * Dev-only component.
 * Shows raw JSON data e.g. API responses
 * */
export const RawData = ({
  data,
  title = 'Toggle raw data',
  alwaysExpand = false,
  disableButton = false,
}: RawDataProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldShowButton = !(alwaysExpand || disableButton);
  return (
    <Box sx={{ mt: 4 }}>
      {shouldShowButton && (
        <Button onClick={() => setIsExpanded(!isExpanded)} color='primary' variant='secondary'>
          {title}
        </Button>
      )}
      <Collapse in={isExpanded || alwaysExpand}>
        <JSONPretty data={data} />
      </Collapse>
    </Box>
  );
};
